<div class="content tw-flex tw-flex-row tw-flex-wrap">
  <mat-card class="card tw-m-6">
    <a
      id="system-admin-select-btn"
      class="!tw-w-96 !tw-h-48 text-lg"
      href="/devices"
      mat-raised-button
      color="primary"
      (click)="saveSystemAdmin()"
    >
      <p class="tw-text-3xl">管理者メニュー</p>
    </a>
  </mat-card>
  @for (tenant of tenantList; track tenant.tenantId; let idx = $index) {
    <mat-card class="card tw-m-6">
      <a
        [id]="'tenant-' + idx + '-select-btn'"
        class="!tw-w-96 !tw-h-48"
        href="/"
        mat-raised-button
        color="primary"
        (click)="saveTenantId(tenant.tenantId)"
        (click)="saveTenantCreatedAt(tenant.createdAt)"
      >
        <p class="tw-text-3xl">{{ tenant.tenantName }}</p>
      </a>
    </mat-card>
  }
</div>
